import React, { Component } from 'react'
import { Switch, withRouter, Route } from 'react-router-dom'

import { ClientAdminRoute } from 'Config/Routing/auth'
import UserManagement from 'Containers/UserManagement'
import UserManagementDetailsAdd from 'Containers/UserManagement/UserDetails/Add'
import UserManagementDetailsView from 'Containers/UserManagement/UserDetails/View'
import UserManagementDetailsEdit from 'Containers/UserManagement/UserDetails/Edit'

import { PATHS } from 'Config/Routing/paths'

class UserManagementRouter extends Component {
  render() {
    return (
      <Switch>
        <Route exact path={`${this.props.match.url}`}>
          <ClientAdminRoute>
            <UserManagement />
          </ClientAdminRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.url}${
            PATHS.userManagement.userManagementDetailsCreate
          }`}
        >
          <ClientAdminRoute>
            <UserManagementDetailsAdd />
          </ClientAdminRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.url}${
            PATHS.userManagement.userManagementDetailsView
          }`}
        >
          <ClientAdminRoute>
            <UserManagementDetailsView />
          </ClientAdminRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.url}${
            PATHS.userManagement.userManagementDetailsEdit
          }`}
        >
          <ClientAdminRoute>
            <UserManagementDetailsEdit />
          </ClientAdminRoute>
        </Route>
      </Switch>
    )
  }
}

export default withRouter(UserManagementRouter)



// WEBPACK FOOTER //
// ./src/Config/Routing/UserManagement.js